export const getById = (state) => (id) => {
  if (state.items[id]) {
    return state.items[id]
  }
  return null
}
